<template>
    <div class="first">
        <div class="grid-list">

            <div class="grid-content">
                <div>
                    营业收入(元)
                </div>
                <div>
                    {{ businessInfo.businessIncome }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    营业额(元)
                </div>
                <div>
                    {{ businessInfo.businessAmount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    优惠金额(元)
                </div>
                <div>
                    {{ businessInfo.discountAmount }}
                </div>
            </div>
            <div class="grid-content">
                <div>
                    优惠占比(元)
                </div>
                <div>
                    {{ businessInfo.discountRate }}%
                </div>
            </div>
            <div class="grid-content">
                <div>
                    订单量(单)
                </div>
                <div>
                    {{ businessInfo.orderCount }}
                </div>
            </div>
        </div>
        <span class="title">营业构成</span>
        <div class="line"></div>
        <div class="data-card-box">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card class="card-box">
                        <div class="card-header">
                            <div class="card-header-left">
                                <el-image class="img" :src="require('@/assets/images/icon-data.png')"></el-image>
                                <span>销售品项构成</span>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="card-content-top">
                                <span class="name">营业额(元)</span>
                                <span class="num">{{ businessInfo.businessAmount }}</span>
                            </div>
                            <div class="card-content-bottom">
                                <!--  <el-collapse @change="handleChange" accordion v-model="activeNames">
                                    <el-collapse-item name="1">
                                        <template slot="title">
                                            <i class="collapse-icon"
                                                :class="collapse === '1' ? 'el-icon-minus' : 'el-icon-plus'"></i>菜品销售
                                        </template>

</el-collapse-item>
</el-collapse> -->
                                <div class="no-scrollbar">
                                    <div class="collapse-item">
                                        <span>营业收入</span>
                                        <span>{{ dataInfo.businessIncome }}</span>
                                    </div>
                                    <div class="collapse-item">
                                        <span>营业额</span>
                                        <span>{{ dataInfo.businessAmount }}</span>
                                    </div>
                                    <div class="collapse-item">
                                        <span>优惠金额</span>
                                        <span>{{ dataInfo.discountAmount }}</span>
                                    </div>
                                    <div class="collapse-item">
                                        <span>优惠占比</span>
                                        <span>{{ dataInfo.discountRate }}%</span>
                                    </div>
                                    <div class="collapse-item">
                                        <span>订单量</span>
                                        <span>{{ dataInfo.orderCount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="card-box">
                        <div class="card-header">
                            <div class="card-header-left">
                                <el-image class="img" :src="require('@/assets/images/icon-data.png')"></el-image>
                                <span>营业收入构成</span>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="card-content-top">
                                <span class="name">营业收入(元)</span>
                                <span class="num">{{ businessInfo.businessIncome }}</span>
                            </div>
                            <div class="card-content-bottom">
                                <div class="no-scrollbar">
                                    <div class="collapse-item" v-for="(item, index) in dataList1" :key="index">
                                        <span>{{ item.payTypeName }}</span>
                                        <span>{{ item.businessIncome }}</span>
                                    </div>
                                </div>
                                <!-- <el-collapse @change="handleChange" accordion v-model="activeNames2">
                                    <el-collapse-item name="2">
                                        <template slot="title">
                                            <i class="collapse-icon"
                                                :class="collapse === '2' ? 'el-icon-minus' : 'el-icon-plus'"></i>会员卡
                                        </template>
                                        


                                    </el-collapse-item>
                                </el-collapse> -->
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        dateTime: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            activeNames: ['1'], // 默认展开的面板
            activeNames2: ['2'],
            collapse: '1',
            businessInfo: {
                businessIncome: 0,
                businessAmount: 0,
                discountAmount: 0,
                discountRate: 0,
                orderCount: 0
            },
            dataList1: [],
            dataInfo: {}
        };
    },
    methods: {
        handleChange(e) {
            this.collapse = e
            console.log(e)
        },
        async getData() {
            let startTime = null
            let endTime = null
            if (this.dateTime.length > 0) {
                startTime = this.dateTime[0]
                endTime = this.dateTime[1]
            }
            let params = {
                startTime: startTime,
                endTime: endTime,
                merchantCode: localStorage.getItem('merchantCode')
            }
            let res = await this.$http.post('/businessOverview/businessStatistics', params)
            if (res.data.code == 200) {
                this.businessInfo = res.data.data
            }
            let res2 = await this.$http.post('/businessOverview/incomeCompose', params)
            if (res2.data.code == 200) {
                this.dataList1 = res2.data.data
            }
            let res3 = await this.$http.post('/businessOverview/saleCompose', params)
            if (res3.data.code == 200) {
                this.dataInfo = res3.data.data
            }

        }
    }
};
</script>

<style scoped lang="scss">
.first {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    margin: 20px auto;
}

.grid-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    gap: 20px;
    width: 98%;

    .grid-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        height: 100px;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding-left: 20px;
        margin-bottom: 20px;

        div:nth-child(1) {
            font-size: 16px;
            color: #999;
        }

        div:nth-child(2) {
            font-size: 28px;
            color: #333;
        }
    }
}

.title {
    font-size: 18px;
    color: #333;
    position: relative;

}

.title::after {
    content: '';
    width: 100%;
    height: 4px;
    background-color: rgba(255, 189, 0, .7);
    position: absolute;
    bottom: 3px;
    left: 0;
}

.line {
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 4px;
    margin-bottom: 20px;
}

.data-card-box {
    width: 98%;
    margin-top: 20px;
}

.card-box {
    height: 400px;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-header-left {
        display: flex;
        align-items: center;

        .img {
            width: 20px;
            height: 20px;
        }

        span {
            margin-left: 4px;
        }
    }
}

.card-content {
    .card-content-top {
        font-size: 16px;
        color: #000;
        margin-top: 10px;
        background: #fafafa;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        border-radius: 4px;

        .name {
            font-size: 16px;
            color: #333;
        }

        .num {
            font-size: 16px;
            color: #333;
        }
    }

    .card-content-bottom {
        margin: 4px;

        .collapse-icon {
            border: 1px solid #ccc;
            padding: 2px;
            margin-right: 10px;
            cursor: pointer;
        }

        .collapse-item {
            margin: auto;
            margin-top: 10px;
            width: 90%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            border-bottom: 1px solid #dddddd;
        }

        /* .collapse-item:first-child {
            border-top: 1px solid #dddddd;

        } */
    }
}

/deep/ .el-collapse-item__arrow {
    display: none;
}

.no-scrollbar {
    overflow-y: auto;
    /* 启用垂直滚动 */
    height: 300px;
    padding-right: 20px;
}

/* 定义滚动条的样式 */
::-webkit-scrollbar {
    width: 12px;
    /* 滚动条的宽度 */
}

/* 定义滚动条轨道的样式 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道的背景颜色 */
}

/* 定义滚动条的样式 */
::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条的背景颜色 */
    border-radius: 6px;
    /* 滚动条的圆角 */
}

/* 当鼠标悬停在滚动条上时，改变滚动条的颜色 */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滚动条的背景颜色 */
}
</style>